import type { IconDefinition } from '../index.tsx';

export const iconDownload: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconDownload',
  icon: [
    16,
    16,
    [],
    '',
    'M13 7H10V0H6V7L3 7V8L8 13L13 8V7Z M14 14H2V16H14V14Z',
  ],
};
